import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: ${props => props.center ? 'center' : props.end ? 'flex-end' : 'flex-start'};
  margin: ${props => props.marg && props.marg};
  padding: ${props => props.pad && props.pad};
  border-radius: ${props => props.hasRadius && props.hasRadius};
  background-color: ${props => props.bg && props.bg};
  align-items: ${props => props.centerAll && 'center'};
  border: ${props => props.border && '1px solid #ddd'};
  max-width: ${props => props.maxWid && props.maxWid};
  min-width: ${props => props.minWid && props.minWid};
  justify-content: ${props => props.between ? 'space-between' : props.evenly ? 'space-evenly' : props.start ? 'flex-start' : 'center'};
  height: ${ props => props.fullHt ? '100vh' : props.ht || 'auto'};
  width: ${props => props.wid || 'auto'};

  ${props => props.pointer && css`
    cursor: pointer;

    p {
      cursor: pointer
    }
  `};

  ${props => props.hasFade && css`
      animation: ${fadeIn} 0.3s linear;
  `};

  ${props => props.stretch && css`
    align-self: stretch;
  `};

  ${props => props.noFlex && css`
    flex: unset;
  `}
`

export default Col
